// Ported verbatim from the Claude Design prototype. Placeholder photos + "vigencia"
// dates -- these are examples of the format, not real August 2026 promos yet.
export const PROMOS = [
  {
    id: 'p1',
    nombre: 'Manos y pies',
    desc: 'Manicure ruso con semipermanente más pedicure spa en la misma cita.',
    precio: '$790',
    antes: '$900',
    vigencia: 'Válido todo agosto',
    foto: 'Manos y pies terminados',
  },
  {
    id: 'p2',
    nombre: 'Ritual de descanso',
    desc: 'Masaje relajante de 60 minutos con facial hidratante el mismo día.',
    precio: '$1,150',
    antes: '$1,300',
    vigencia: 'Válido todo agosto',
    foto: 'Cabina y aceites',
  },
  {
    id: 'p3',
    nombre: 'Primera vez en pestañas',
    desc: 'Extensiones clásicas con 20% de descuento en tu primer juego.',
    precio: '$560',
    antes: '$700',
    vigencia: 'Solo clientas nuevas',
    foto: 'Detalle de mirada',
  },
  {
    id: 'p4',
    nombre: 'Martes de facial',
    desc: 'Limpieza facial profunda con precio especial todos los martes del mes.',
    precio: '$620',
    antes: '$750',
    vigencia: 'Martes de agosto',
    foto: 'Cabina facial',
  },
];
